"use strict"

import _ from "lodash"
import angular from "angular"

angular
  .module("uCountitUiApp")

  .controller("PushConfigCtrl", function ($scope) {
    $scope.protocols = [
      { value: "sftp", name: "SFTP" },
      { value: "ftp", name: "FTP" },
    ]

    $scope.contents = [
      { name: "Footfall", value: "footfall" },
      { name: "Gender/Age", value: "genderage" },
      { name: "Zone Traffic", value: "zonetraffic" },
      { name: "Flowmap", value: "flowmap" },
      { name: "Heatmap Image", value: "heatmapImg" },
    ]

    $scope.showProtocolsConfig = function (protocol) {
      return (
        $scope.form &&
        $scope.form.active &&
        $scope.config.active &&
        $scope.config.protocol === protocol
      )
    }

    $scope.hasPassword = function (protocol) {
      return $scope.originalForm && $scope.originalForm?.push?.[protocol]?.hasPassword
    }

    $scope.disablePasswordChange = function (protocol) {
      return !$scope.config?.[protocol]?.passwordChange
    }

    $scope.protocol = {
      options: [
        { value: "sftp", name: "SFTP" },
        { value: "ftp", name: "FTP" },
      ],
    }
    $scope.protocol.selected = $scope.protocol.options[0]

    $scope.$watch("protocol.selected", function (protocol) {
      if (protocol && $scope.config) {
        $scope.config.protocol = protocol.value
      }
    })

    $scope.$watch("form", function (form) {
      const pushConfig = form.push
      if (pushConfig) {
        // TODO: toggleable active when more services are added
        pushConfig.active = true

        const selected = _.find($scope.protocol.options, { value: pushConfig.protocol })
        $scope.protocol.selected = selected || $scope.protocol.options[0]

        if (pushConfig?.sftp?.hasPassword) {
          pushConfig.sftp.passwordChange = false
        } else {
          pushConfig.sftp.passwordChange = true
        }
        if (pushConfig?.ftp?.hasPassword) {
          pushConfig.ftp.passwordChange = false
        } else {
          pushConfig.ftp.passwordChange = true
        }
      }

      $scope.config = pushConfig
    })
  })
